import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type { PrescriptionBenefitsResponse } from "../types";

export type {
  PrescriptionBenefitsResponse,
  RxBenefitsAlternative,
  RxBenefitsPatientSpecificPricingCoverage,
  RxBenefitsPricingCoverage,
} from "../types";

interface RxPrescriptionBenefitsParams {
  patientId: string;
  ndc: string;
  pharmacyId: number;
  quantity: number;
  daysSupply: number;
  dispenseUnitTypeId: number;
  patientEligibilityId?: number;
  enabled: boolean;
}

export const useRxPrescriptionBenefits = ({
  patientId,
  ndc,
  pharmacyId,
  quantity,
  daysSupply,
  dispenseUnitTypeId,
  patientEligibilityId,
  enabled,
}: RxPrescriptionBenefitsParams) =>
  useApi<PrescriptionBenefitsResponse>({
    queryOptions: {
      enabled: Boolean(
        patientId &&
          ndc &&
          pharmacyId &&
          quantity &&
          daysSupply &&
          dispenseUnitTypeId &&
          enabled,
      ),
      staleTime: 0,
      queryFn: async () => {
        const response = await axiosInstance.get(
          "/rx/eligibility/prescriptionbenefits",
          {
            params: {
              patient_id: patientId,
              ndc,
              pharmacy_id: pharmacyId,
              quantity,
              days_supply: daysSupply,
              dispense_unit_type_id: dispenseUnitTypeId,
              ...(patientEligibilityId !== undefined && {
                patient_eligibility_id: patientEligibilityId,
              }),
            },
          },
        );
        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.PrescriptionBenefits.DEFAULT(
        patientId,
        ndc,
        pharmacyId,
        quantity,
        daysSupply,
        dispenseUnitTypeId,
        patientEligibilityId,
      ),
    },
  });
